export enum SideBarOptions {
  rated_current = 'ratedCurrent',
  curve = 'curve',
  breaking_capacity = 'breakingCapacity',
  rcd_type = 'rcdType',
  leakage_current = 'leakageCurrent',
  pole_contact_composition = 'poleContactComposition',
  available_function = 'availableFunction',
  label = 'label',
  specification = 'specification',
  applicationGroup = 'applicationGroup',
  description = 'description',
  channel = 'channel',
  type = 'type',
  protocol = 'protocol',
  certification = 'certification',
  power = 'power',
  connection = 'connection',
  breaking_capacity_IEC_60947_2 = 'breaking_capacity_IEC_60947_2',
  tripUnit = 'tripUnit',
  frameRating = 'frameRating',
  feeding = 'feeding',
  zigbee = 'zigbee',
  controlVoltage = 'control_voltage',
  maximumCurrent = 'maximum_current',
  supplyVoltage = 'supply_voltage',
  maximumDischargeCurrent = 'maximum_discharge_current',
  channelNumber = 'channel_number',
  supplyCurrent = 'supply_current',
  binaryInputs = 'binary_inputs',
  bidirectional = 'bidirectional'
}

export enum PrimitiveProductAttributes {
  rated_current = 'ampere',
  curve = 'kurve',
  breaking_capacity = 'type',
  rcd_type = 'type2',
  leakage_current = 'leakageCurrent',
  pole_name = 'poleName',
  available_function = 'availableFunction',
  specification = 'specification',
  channel = 'Channel',
  protocol = 'Protocol',
  mid_certification = 'MID_certification',
  type = 'Type',
  power = 'Power',
  connection = 'Connection',
  breaking_capacity_IEC_60947_2 = 'Breaking_capacity_IEC_60947_2',
  tripUnit = 'Trip_Unit',
  frameRating = 'Frame_Rating',
  feeding = 'Feeding',
  zigbee = 'Zigbee',
  controlVoltage = 'Control_circuit_voltage',
  maximumCurrent = 'Maximum_current',
  supplyVoltage = 'Supply_voltage',
  maximumDischargeCurrent = 'Maximum_discharge_current',
  channelNumber = 'channel_number',
  supplyCurrent = 'supply_current',
  binaryInputs = 'binary_inputs',
  bidirectional = 'Bidirectional'
}

export enum CustomDevicesAttributes {
  reference = 'reference',
  enumber = 'enumber',
  price = 'price',
  width = 'width',
  EC_width = 'EC_width',
  description = 'description',
  label = 'label'
}

export enum FeedingTreeAttributes {
  feedInDescription = 'feedInDescription'
}

export interface ICustomDeviceWidthDD {
  values: number[];
  selected: number;
}
